import { parseServerTimestamp } from "./traceUtils.js";

// Typed trace-tool activity rows retain source truncation flags.
export function shapeToolExecutions(rows) {
  return (rows || []).map((row) => ({
    id: String(row.tool_event_id), name: row.name || "tool",
    // Empty for a provider that reported no call id; readers key on it to date
    // a captured tool_use block, and an empty key must never match one.
    toolUseId: row.tool_use_id ? String(row.tool_use_id) : "",
    timestamp: row.tool_time ? parseServerTimestamp(row.tool_time) : null,
    isError: row.isError === true, input: row.input ?? "", result: row.result ?? "",
    inputTruncated: row.inputTruncated === true, resultTruncated: row.resultTruncated === true,
  }));
}
